import * as z from "zod";
import { discountRescueInput } from "./discount-rescue-shared";

export const getDiscountRescueFunnel = {
  name: "getDiscountRescueFunnel" as const,
  input: discountRescueInput,
  output: z.object({
    failedDetected: z.number(),
    claimed: z.number(),
    ordered: z.number(),
  }),
};
